import React from "react";
import styled from "styled-components";
import isEmpty from "lodash/isEmpty";

const Label = styled.div`
  // font-size: 0.8rem;
  font-weight: bold;
`;

const Value = styled.div``;

const Wrapper = styled.div`
  margin-bottom: 15px;
`;

const Summary = (props) => {
  const { nodeId, nodes = {}, data = {} } = props;

  const value = props.value ? props.value : data[nodeId];
  const node = nodes[nodeId];

  const { extra = {}, type } = node;
  const { label } = extra;

  if (isEmpty(value)) {
    return null;
  }

  if (value === "_remove") {
    return null;
  }

  return (
    <Wrapper className={`sp-summary-component sp-summary-${type}`}>
      <Label>{label ? label : type}</Label>
      <Value>{value}</Value>
    </Wrapper>
  );
};

export default Summary;
